import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';
// Icons
import { BsListTask, BsFillPlusCircleFill } from "react-icons/bs";
import { FaSchool, FaUniversity } from "react-icons/fa";
import { GiModernCity, GiByzantinTemple } from "react-icons/gi";

import { AuthContext } from "../store/AuthProvider";

import "./css/components.css";

const Icon = ({ task }) => {
  const sz = 70;
  if (task === "Cities") {
    return <GiModernCity size={sz} />;
  } else if (task === "Schools") {
    return <FaSchool size={sz} />;
  } else if (task === "Temples") {
    return <GiByzantinTemple size={sz} />;
  } else if (task === "Colleges") {
    return <FaUniversity size={sz} />;
  } else if (task === "addProblems") {
    return <BsFillPlusCircleFill color="green" size={sz} />;
  } else {
    return <BsListTask size={sz} />;
  }
};

const OneChoice =styled.span`
  color:${ props=>props.num%2 ?'rgba(0, 60, 255, 1)' : 'rgba(0,123,255, 1)' };
  background:${ props=>props.num%2 
                  ?'linear-gradient(to bottom, rgba(0, 60, 255, 0.05), rgba(0, 60, 255, 0.1))' 
                  : 'linear-gradient(to bottom, rgba(0, 123, 255, 0.05), rgba(0, 123, 255, 0.1))'  };

  height: fit-content;
  padding: 3px 9px;
  margin: 5px;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 1.5px 5px 0 rgba(0, 0, 0, 0.19);
    background:${ props=>props.num%2 
                    ?'linear-gradient(to bottom, rgba(0, 60, 255, 0.05), rgba(0, 60, 255, 0.25))' 
                    : 'linear-gradient(to bottom, rgba(0, 123, 255, 0.05), rgba(0, 123, 255, 0.25))' };
  }
`;

const Extra =styled(OneChoice)`
  color: grey;  
  background: none;

  padding: 5px;
  margin: 5px;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background: rgb(235, 235, 235);
  }
`;


const Tasks = () => {
  // GET the tasks/domains from the backend OR Keep it fixed if only handful of tasks
  const [tasks, setTasks] = useState([]);
  const { _, utypeState } = useContext(AuthContext);
  const [utype, setUtype] = utypeState;
  useEffect(() => {
    const getTasksList = async () => {
      const response = await fetch(`${process.env.REACT_APP_API}/task`);
      const data = await response.json();
      setTasks(data.response);
    };
    getTasksList();
  }, []);

  const filters ={
    Langugage: ['English', 'Hindi', 'Telugu', 'Tamil', 'Marathi'],
    Multilinguality:['monolingual', 'multilingual', 'translation', 'transliteration'],
    Tags:['Cities', 'Wiki', 'Schools', 'Temples'],
    Author:['Arnold', 'Baburao', 'Chandini', 'Dom', 'Eshwar', 'Fanny', 'Ganesh', 'Harry', 'Ian', 'Jacob', 'Kate', 'Larry', 'Mangesh']
  }

  return (
    <div className='taskSpace'>

      <div className="filterSpace" id="filterSpaceID">
        <div className="allCategories">
        {Object.keys(filters).map((oneCategory, index) =>(
          <div className="oneCategory" key={index}>
            <div style={{fontSize:'130%', marginTop:'10px'}}>{oneCategory}</div> 
            <div className="categoryChoices">
              <>
                {filters[oneCategory].splice(0,4).map((choice)=>(
                  <OneChoice key={choice} num={index}>
                    {choice}
                  </OneChoice>
                ))}
                {filters[oneCategory].length > 4 &&
                  <Extra key='extra'>
                    +{filters[oneCategory].length-4}
                  </Extra>
                }
              </>
            </div>
          </div>
        ))}
        </div>
    
        
      </div>


      <div className="flexRowWrap justify-content-center tasksList">
        {utype === "admin" && (
          <Link to={"/addProblems"} key="0">
            <div className="box task addProblems">
              <div className="name">
                <span className="spChar">A</span>dd Problems
              </div>
              <div className="alignCenter">
                <Icon task="addProblems" />
              </div>
            </div>
          </Link>
        )}
        {tasks.map((task) => (
          <Link to={`/task=${task._id}`} key={task._id}>
            <div className="box task">
              <div className="name">
                <span className="spChar">{task.name[0]}</span>
                {task.name.slice(1)}
              </div>
              <div className="alignCenter">
                <Icon task={task.name} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    
    </div>
  );
};

export default Tasks;
